import React from 'react';

const SvgDiscord = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <path
      d="M13.86 2.96A13.2 13.2 0 0 0 10.6 2a9.9 9.9 0 0 0-.44.89 12.2 12.2 0 0 0-3.66 0A9.9 9.9 0 0 0 6.06 2a13.2 13.2 0 0 0-3.26.96A13.6 13.6 0 0 0 .51 12.69a13.3 13.3 0 0 0 4.04 2.04c.33-.44.62-.91.86-1.4a8.6 8.6 0 0 1-1.36-.65c.11-.08.22-.17.33-.25a9.5 9.5 0 0 0 8.1 0c.1.09.22.17.33.25a8.6 8.6 0 0 1-1.36.65c.25.5.54.96.87 1.4a13.3 13.3 0 0 0 4.04-2.04 13.6 13.6 0 0 0-2.29-9.73ZM5.82 10.68c-.84 0-1.54-.77-1.54-1.72S4.96 7.24 5.8 7.24c.85 0 1.55.77 1.54 1.72 0 .95-.69 1.72-1.54 1.72Zm5.35 0c-.85 0-1.54-.77-1.54-1.72s.68-1.72 1.54-1.72c.85 0 1.54.77 1.54 1.72s-.69 1.72-1.54 1.72Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgDiscord;
